import { Box, Stack, Tab, Tabs } from '@mui/material';
import { SyntheticEvent, useCallback, useState } from 'react';
import MenusDisplayContentTab from '../menus-display-content-tab/menus-display-content-tab.component';
import { DisplayInfo } from 'api/ordering-service/ordering-service.types';
import { useTranslation } from 'react-i18next';
import DisplayContentInfo from './display-content-info/display-content-info.component';

type MenusDisplayContentTabsProps = {
  displayInfos: DisplayInfo[];
};

const MenusDisplayContentTabs = ({
  displayInfos,
}: MenusDisplayContentTabsProps) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(0);

  const handleChange = (_e: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const languageTitle = useCallback((langCode: 'EN' | 'ES' | 'FR') => {
    switch (langCode) {
      case 'EN':
        return 'English';
      case 'ES':
        return 'Spanish';
      case 'FR':
        return 'French';
    }
  }, []);

  return (
    <Box sx={{ width: '100%' }} data-testid="MenusDisplayContent.Tabs">
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} variant="fullWidth">
          {displayInfos?.map((info: DisplayInfo) => (
            <Tab key={info.langCode} label={languageTitle(info.langCode)} />
          ))}
        </Tabs>
      </Box>
      {displayInfos?.map((info: DisplayInfo, index: number) => (
        <MenusDisplayContentTab key={info.langCode} value={value} index={index}>
          <DisplayContentInfo
            title={t('drawer.menusDetailsDrawer.displayContent.title.label')}
            value={info?.title}
            data-testid="Title"
          />
          {info?.shortDescription && (
            <DisplayContentInfo
              title={t(
                'drawer.menusDetailsDrawer.displayContent.shortDescription.label',
              )}
              value={info.shortDescription}
              data-testid="ShortDescription"
            />
          )}
          {info?.longDescription && (
            <DisplayContentInfo
              title={t(
                'drawer.menusDetailsDrawer.displayContent.longDescription.label',
              )}
              value={info.longDescription}
              data-testid="LongDescription"
            />
          )}
          <Stack direction="row" spacing={2}>
            {info?.smallImage?.length > 0 && (
              <DisplayContentInfo
                title={t(
                  'drawer.menusDetailsDrawer.displayContent.smallImage.label',
                )}
                value={info?.smallImage}
                data-testid="SmallImage"
                smallImage
              />
            )}
            {info?.mediumImage?.length > 0 && (
              <DisplayContentInfo
                title={t(
                  'drawer.menusDetailsDrawer.displayContent.mediumImage.label',
                )}
                value={info?.mediumImage}
                data-testid="MediumImage"
              />
            )}
          </Stack>
        </MenusDisplayContentTab>
      ))}
    </Box>
  );
};

export default MenusDisplayContentTabs;
